"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VitalType = exports.FrustrationType = exports.ActionType = exports.ViewLoadingType = exports.RumLongTaskEntryType = exports.RumEventType = void 0;
exports.RumEventType = {
    ACTION: 'action',
    ERROR: 'error',
    LONG_TASK: 'long_task',
    VIEW: 'view',
    RESOURCE: 'resource',
    VITAL: 'vital',
};
exports.RumLongTaskEntryType = {
    LONG_TASK: 'long-task',
    LONG_ANIMATION_FRAME: 'long-animation-frame',
};
exports.ViewLoadingType = {
    INITIAL_LOAD: 'initial_load',
    ROUTE_CHANGE: 'route_change',
    BF_CACHE: 'bf_cache',
};
exports.ActionType = {
    CLICK: 'click',
    CUSTOM: 'custom',
};
exports.FrustrationType = {
    RAGE_CLICK: 'rage_click',
    ERROR_CLICK: 'error_click',
    DEAD_CLICK: 'dead_click',
};
exports.VitalType = {
    DURATION: 'duration',
    OPERATION_STEP: 'operation_step',
};
//# sourceMappingURL=rawRumEvent.types.js.map